import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import "./HomePage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import SelectDevice from "../components/SelectDevice";
import BackButton from "../components/BackButton";

const SelectDevicePage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "انتخاب دستگاه و خروجی",
      slug: "home",
    });
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <div className="col-12 col-md-10 col-lg-8 w-100 h-100 mx-auto">
            <div className="card h-100" style={{ backgroundColor: "#fff0", boxShadow: "none" }}>
              <div className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2">
                <h5>انتخاب دستگاه و خروجی ها</h5>
                <div>
                  <BackButton />
                </div>
              </div>
              <div className="card-body scrollbar mt-5">
                <SelectDevice />
              </div>
            </div>
          </div>
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default SelectDevicePage;
